import type { BenchmarkRun } from '@/types'

export function downloadFile(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export function exportJson(run: BenchmarkRun): void {
  // Export raw data only — stats can be recomputed from results
  const { stats, ...rawRun } = run
  downloadFile(JSON.stringify(rawRun, null, 2), `benchmark-${run.id}.json`, 'application/json')
}

function escapeCSV(value: string | number | boolean | undefined): string {
  if (value === undefined || value === null) return ''
  const str = String(value)
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export function exportCsv(run: BenchmarkRun): void {
  const columns = [
    'call_id', 'profile_name', 'profile_type', 'prompt', 'max_tokens', 'success',
    'total_time_sec', 'ttft_sec', 'max_gap_sec', 'chunk_count', 'output_chars',
    'input_tokens', 'output_tokens', 'request_id',
    'bedrock_invocation_latency_ms', 'bedrock_first_byte_latency_ms',
    'guardrail_input_latency_ms', 'guardrail_output_latency_ms', 'guardrail_total_latency_ms',
    'token_throughput', 'stop_reason', 'error',
    'lambda_region', 'api_endpoint_region', 'inference_profile_type', 'inference_profile_geo', 'model_id',
    'timestamp'
  ]

  const rows = [columns.join(',')]
  for (const r of run.results) {
    const row = [
      r.callId, r.profileName, r.profileType, r.prompt, r.maxTokens, r.success,
      r.totalTimeSec, r.ttftSec, r.maxGapSec, r.chunkCount, r.outputChars,
      r.inputTokens, r.outputTokens, r.requestId,
      r.bedrockInvocationLatencyMs, r.bedrockFirstByteLatencyMs,
      r.guardrailInputLatencyMs, r.guardrailOutputLatencyMs, r.guardrailTotalLatencyMs,
      r.tokenThroughput, r.stopReason, r.error ?? '',
      r.lambdaRegion ?? '', r.apiEndpointRegion ?? '', r.inferenceProfileType ?? '', r.inferenceProfileGeo ?? '', r.modelId ?? '',
      r.timestamp
    ]
    rows.push(row.map(escapeCSV).join(','))
  }

  downloadFile(rows.join('\n'), `benchmark-${run.id}.csv`, 'text/csv')
}
